import Market from './market'
import MarketQuartile from './marketQuartile'
import YearlyQuartileScoresReport from './yearlyQuartileScoresReport'
import Message from './message'

const PropShapes = {
  Market,
  MarketQuartile,
  YearlyQuartileScoresReport,
  Message
}

export default PropShapes
